import { Button, Dialog } from "@material-ui/core";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import React, { useState } from "react";
import NewTradeModal from "../newTradeModal";

const TradeButton = (props) => {
  const {
    disabled,
    model: { tradedByMe, tradedBy },
  } = props;

  const [modalOpened, setModalOpened] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const closeModal = () => setModalOpened(false);

  return (
    <>
      <Button
        disableTouchRipple
        className="qd-trade-btn"
        size="large"
        disabled={tradedByMe || !!tradedBy || buttonDisabled || disabled}
        onClick={() => setModalOpened(true)}
        startIcon={<BusinessCenterIcon />}
      >
        {tradedByMe
          ? "ESTOU NEGOCIANDO"
          : tradedBy
          ? `EM NEGOCIAÇÃO POR ${tradedBy}`
          : "NEGOCIAR"}
      </Button>

      <Dialog
        open={modalOpened}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
        style={{
          maxHeight: "600px",
          width: "500px",
          margin: "auto",
        }}
      >
        {
          <NewTradeModal
            disableBtn={() => setButtonDisabled(true)}
            closeModal={closeModal}
            {...props}
          />
        }
      </Dialog>

      <div className="q-clear" />
    </>
  );
};

export default TradeButton;
